import React, {useEffect} from 'react';
import {PageHeader, Select} from 'antd';
import {CollectionWorkProjectType} from '../../hooks/apis/useCollectionWork';
import {SelectProps} from 'antd/lib/select';
import UseCollectionWorkProject, {ICollectionWorkProject} from '../../hooks/apis/useCollectionWorkProject';
import CommonApiErrorHandler from '../../utils/HttpInstance';

interface IProps extends SelectProps<number> {
  collectionWorkId?: number;
}
const CollectionWorkProjectSelector = (props: IProps) => {
  const listHook = UseCollectionWorkProject.list();
  useEffect(() => {
    listHook
      .request({collectionWorkId: props.collectionWorkId})
      .then()
      .catch(CommonApiErrorHandler);
  }, [props.collectionWorkId]);
  return (
    <Select {...props}>
      {listHook.data?.map(i => (
        <Select.Option key={i.id} value={i.id}>
          {i.name}
        </Select.Option>
      ))}
    </Select>
  );
};
export default CollectionWorkProjectSelector;
